const SITE_NAME = '亚讯体育'
const EXPERT_KEYWORDS = [
  '足球心水推荐', '足球分析专家', '足球分析预测', '足球分析推荐',
  '足球分析论坛', '足球赛前分析', '足球分析网站', '足球贴士平台',
  '足球推荐专家', '足球推介专家', '足球贴士网站'
]

const PAGE_SEO = {
  '/': {
    title: '亚讯体育｜认证专家贴士、赛前分析与真实战绩',
    description: '亚讯体育汇集认证专家，提供足球赛前分析、赛事预测、真实战绩、即时比分和原创研究。',
    label: 'YAXUN ANSWER LAB · HOME',
    heading: '亚讯首页数据导航',
    subtitle: '从赛事雷达、专家智库到赛果复盘，快速理解首页数据',
    questions: [
      ['亚讯赛事雷达如何挑选首页比赛？', '优先显示已有专家发布记录的当日主要赛事；当日场次不足时，按时间和关注度补充最近赛程。'],
      ['亚讯专家智库为什么默认展示近7天？', '近7天能兼顾样本新鲜度与可读性，同时保留历史分析、关注人数和热销场次供交叉核对。'],
      ['亚讯精选研判怎样核对赛后结果？', '观点卡保留专家、发布时间和对应比赛，赛后再写入红、黑、和结果，访客可沿原记录复盘。']
    ]
  },
  '/recommend': {
    title: '专家贴士｜认证专家当天赛事分析 - 亚讯体育',
    description: '查看亚讯体育认证专家的当天足球贴士、让球数据、大小数据和可核验的历史分析。',
    label: 'YAXUN ANSWER LAB · PICKS',
    heading: '亚讯专业分析使用说明',
    subtitle: '围绕球队信息、数据档案与赛果留痕解释贴士卡片',
    questions: [
      ['亚讯专业分析先核对哪三类信息？', '先核对开赛时间与对阵，再看阵容可用性，最后把让球、大小和球队近况放在同一时间点比较。'],
      ['权威数据档案在贴士卡片哪里查看？', '卡片同时展示专家身份、近7天统计、发布时间和赛后结果，点击专家或比赛可继续查看历史记录。'],
      ['亚讯为什么不把预测写成必然结果？', '赛前判断只能反映发稿时信息，首发、伤停和临场变化会改变条件，因此必须保留风险边界。']
    ]
  },
  '/rank': {
    title: '足球专家排行｜真实战绩、回报率与稳定性 - 亚讯体育',
    description: '按真实发布记录查看足球分析专家的周期战绩、胜率、回报率、稳定性、关注人数和热销场次。',
    label: 'YAXUN ANSWER LAB · RANK',
    heading: '亚讯专家数据档案解读',
    subtitle: '用周期、样本量和表现稳定性阅读专家排行',
    questions: [
      ['亚讯专家排行为什么把近7天设为默认周期？', '短周期便于观察近期状态，同时页面保留近15天、近30天和按场统计，避免只看单一窗口。'],
      ['怎样同时看命中率、样本量与稳定性？', '命中率反映结果比例，历史分析体现样本量，稳定性帮助判断波动，三项应一起阅读。'],
      ['排行榜里的历史分析场次从哪里来？', '场次来自专家在站内已保存的真实发布记录，不用虚拟数量补位，进入专家档案可继续核验。']
    ]
  },
  '/bifen': {
    title: '即时比分｜足球赛程与比赛数据 - 亚讯体育',
    description: '足球即时比分、当天赛程和比赛数据页面，帮助访客核验专家文章对应赛事与赛果。',
    label: 'YAXUN ANSWER LAB · LIVE',
    heading: '亚讯比分核验提示',
    subtitle: '区分实时赛况、赛前观点和最终赛果的时间口径',
    questions: [
      ['亚讯即时比分怎样和专家观点对应？', '通过相同的赛事时间、联赛和对阵核对，观点发布在前，比分更新在后，两者不会混成同一时间口径。'],
      ['开赛后的比分能否反推赛前观点？', '不能。实时比分属于比赛进程，阅读赛前观点时应回到原发布时间与当时可用信息。'],
      ['为什么同一场比赛会出现更新时间差？', '赛程、比分和结算可能来自不同更新节点，亚讯保留各自时间，最终以完成结算后的赛果为准。']
    ]
  },
  '/news': {
    title: '体育资讯｜专家原创足球分析与赛前报告 - 亚讯体育',
    description: '亚讯体育资讯包含认证专家原创分析、赛事研究与深度赛前报告，文章作者和赛事可核验。',
    label: 'YAXUN ANSWER LAB · EDITORIAL',
    heading: '亚讯原创内容校验台',
    subtitle: '说明专家选题、独立关键词和每日GEO问答的生成规则',
    questions: [
      ['亚讯11位专家每天怎样避免选到重复赛事？', '发布任务先按专家已有推荐匹配，再从剩余赛程逐场分配；同一次任务中一场比赛只交给一位专家。'],
      ['一篇亚讯专家新闻为什么附三组独立问答？', '三组问答分别覆盖专家关键词、当日对阵和具体研究角度，帮助搜索与访客直接找到文章要点。'],
      ['亚讯GEO问答如何保持每天不重复？', '问题组合写入发布日期、专家名称、专属关键词和本场对阵，并按文章种子轮换意图模板。']
    ]
  }
}

function setMeta (name, content, property) {
  const attr = property ? 'property' : 'name'
  let node = document.head.querySelector('meta[' + attr + '="' + name + '"]')
  if (!node) {
    node = document.createElement('meta')
    node.setAttribute(attr, name)
    document.head.appendChild(node)
  }
  node.setAttribute('content', content)
}

function setCanonical (url) {
  let link = document.head.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'canonical'
    document.head.appendChild(link)
  }
  link.href = url
}

function setStructuredData (payload) {
  let node = document.getElementById('page-structured-data')
  if (!node) {
    node = document.createElement('script')
    node.type = 'application/ld+json'
    node.id = 'page-structured-data'
    document.head.appendChild(node)
  }
  node.textContent = JSON.stringify(payload)
}

export function seoForPath (path) {
  if (PAGE_SEO[path]) return PAGE_SEO[path]
  if (path.indexOf('/news/') === 0) return {title: '足球赛事研究详情 - ' + SITE_NAME, description: '查看认证专家原创足球分析、赛事数据与可核验的赛前判断。', questions: []}
  if (path.indexOf('/member/') === 0) return {title: '认证足球专家主页 - ' + SITE_NAME, description: '查看亚讯体育认证专家简介、真实战绩和历史赛事分析。', questions: []}
  if (path.indexOf('/recommend/') === 0 || path.indexOf('/match/') === 0) return {title: '足球赛事分析详情 - ' + SITE_NAME, description: '查看赛事对阵、赛前数据、认证专家分析与推荐方向。', questions: []}
  return {title: SITE_NAME + '｜专业足球赛事研究平台', description: '亚讯体育提供足球赛前分析、认证专家预测、真实战绩与赛事数据。', questions: []}
}

export function applyRouteSeo (route) {
  const path = route.path || '/'
  const data = seoForPath(path)
  document.title = data.title
  setMeta('description', data.description)
  setMeta('keywords', EXPERT_KEYWORDS.join('、'))
  setMeta('robots', ['/login', '/register'].indexOf(path) >= 0 || path.indexOf('/my') === 0 ? 'noindex,follow' : 'index,follow')
  setMeta('og:title', data.title, true)
  setMeta('og:description', data.description, true)
  setMeta('og:type', path.indexOf('/news/') === 0 ? 'article' : 'website', true)
  setCanonical(window.location.origin + path)
  const schema = {
    '@context': 'https://schema.org',
    '@type': path.indexOf('/news/') === 0 ? 'Article' : 'WebPage',
    name: data.title,
    description: data.description,
    url: window.location.origin + path,
    isPartOf: {'@type': 'WebSite', name: SITE_NAME, url: window.location.origin + '/'}
  }
  if (data.questions && data.questions.length) {
    schema.mainEntity = data.questions.map(item => ({
      '@type': 'Question',
      name: item[0],
      acceptedAnswer: {'@type': 'Answer', text: item[1]}
    }))
  }
  setStructuredData(schema)
}

export function applyArticleSeo (article, expert) {
  if (!article) return
  const title = article.title + ' - ' + SITE_NAME
  const text = String(article.content || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
  const seo = article.seo || {}
  const description = seo.description || text.slice(0, 155) || '认证专家原创足球赛事分析。'
  const questions = Array.isArray(seo.questions) ? seo.questions : []
  const keywords = Array.isArray(seo.keywords) && seo.keywords.length
    ? seo.keywords
    : [seo.keyword, article.author, '足球专家', '赛前分析', '胜平负预测'].filter(Boolean)
  const articleUrl = window.location.origin + window.location.pathname
  document.title = title
  setMeta('description', description)
  setMeta('keywords', keywords.join('、'))
  setMeta('robots', 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1')
  setMeta('og:title', title, true)
  setMeta('og:description', description, true)
  setMeta('og:type', 'article', true)
  setMeta('article:published_time', article.time || '', true)
  setCanonical(articleUrl)
  const graph = [{
    '@type': 'Article',
    '@id': articleUrl + '#article',
    headline: article.title,
    description: description,
    keywords: keywords.join(', '),
    inLanguage: 'zh-CN',
    author: {'@type': 'Person', name: article.author || (expert && expert.name) || SITE_NAME},
    publisher: {'@type': 'Organization', name: SITE_NAME, url: window.location.origin + '/'},
    datePublished: article.time || undefined,
    dateModified: article.time || undefined,
    about: keywords.map(keyword => ({'@type': 'Thing', name: keyword})),
    mainEntityOfPage: {'@type': 'WebPage', '@id': articleUrl}
  }]
  if (questions.length) {
    graph.push({
      '@type': 'FAQPage',
      '@id': articleUrl + '#faq',
      mainEntity: questions.map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {'@type': 'Answer', text: item.answer}
      }))
    })
  }
  setStructuredData({'@context': 'https://schema.org', '@graph': graph})
}
